import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

export interface MapStyle {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent {
  current_lang = 'it';

  geopos_url = {
    'Cimbri': 'cimbri',
    'Friulani in Veneto': 'friuli',
    'Italiani in Slovenia': 'italiani-in-slovenia',
    'Ladini del Comelico': 'ladini',
    'Sloveni in Italia': 'sloveni-in-italia',
    'Friulani in Friuli Venezia Giulia': 'friuli-fvg'
  };

  constructor(
    private titleService: Title,
    private translate: TranslateService
    ) {
    this.translate.setDefaultLang('it');
    if (this.translate.currentLang) {
      this.current_lang = this.translate.currentLang;
      this.translate.use(this.current_lang);
    } else {
      this.translate.use('it');
      this.current_lang = this.translate.currentLang;
    }
    this.translate.get('breadcrumb.map').subscribe((res: string) => {
      this.titleService.setTitle(res + ' - PRIMIS');
    });
    this.translate.onLangChange.subscribe(() => {
      this.translate.get('breadcrumb.map').subscribe((res: string) => {
        this.titleService.setTitle(res + ' - PRIMIS');
      });
    });
  }

}

